class ImportForm {
  constructor() {
    this.bindEvents()
  }

  bindEvents() {
    const self = this
    const fileInput = document.querySelector('#importRules #file-input')
    const submitBtn = document.querySelector('#importRules #submit-btn')

    document.querySelector('#importRules #import-form').addEventListener('ajax:beforeSend', (event) => {
      if (!fileInput.value) {
        event.preventDefault()
        self.showError(fileInput)
      } else {
        submitBtn.innerHTML = 'Importando...'
        submitBtn.disabled = true
        self.clearError(fileInput)
      }
    })

    document.querySelector('#importRules #close-btn').addEventListener('click', () => {
      window.location.reload()
    })
  }

  showError(fileInput) {
    const feedback = document.querySelector('#importRules .invalid-feedback')
    if (feedback) feedback.style.display = 'block'
    fileInput.classList.add('is-invalid')
  }

  clearError(fileInput) {
    const feedback = document.querySelector('#importRules .invalid-feedback')
    if (feedback) feedback.style.display = 'none'
    fileInput.classList.remove('is-invalid')
  }
}

export default ImportForm
